import React, { FC, useEffect, useState } from "react";
import LABELS from "../../../../constants/labels/pump.labels";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";
import { usePumpFacade } from "../../../../facade/calculation/calculation-output/pump.facade";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/ConfigureStore";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import WidgetLoader from "../../../common/widgetloader";
import Checkbox from "../../../common/checkbox";
import Alert from "../../../../assets/icons/Alert";
import Notification from "../../../common/notification";
import TextShortInput from "../../../common/TextShortInput";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";

interface PumpCalculationDetailsProps { }

const PumpCalculationDetails: FC<PumpCalculationDetailsProps> = () => {
  const { loading } = useAppSelector((state) => state?.pump);
  const PumpInputData = useSelector((state: RootState) => state.pump.PumpInput);
  const PumpInputDataCalculated = useSelector(
    (state: RootState) => state.pump.PumpInputCalculated
  );
  const targetFlowRateForPump = useSelector(
    (state: RootState) => state.gasCalculations.GasFinalCalculatedData
  );
  const schematicData = useSelector(
    (state: RootState) => state.calculations.schematicData
  );

  const { intakeMD } = useAppSelector((state) => state?.calculations);
  const getESPEquipments = useSelector(
    (state: RootState) => state.pump.ESPEquipments
  );
  const fluidDetails = useSelector((state: RootState) => state.fluid);
  const tubingDetails = useSelector((state: RootState) => state.tubing);
  const [isManualOverride, setIsManualOverride] = useState(false);
  const [notification, setNotification] = useState(false);
  const [MOWarning, setMOWarning] = useState(false);
  const [hasRelatedEquipment, setHasRelatedEquipment] = useState(false);
  const { updatehdnPmpShowAll, updateHdnPumpShaftType } = useTubingFacade();
  const {
    updatePumpDesrdStges,
    updatePumpReqdTDH,
    OverrideCorrectionFactors,
    updateESPEquipmentsForPumps,
  } = usePumpFacade();

  const { updateSchematicEquipmentData } = useCalculationFacade();

  useEffect(() => {
    setHasRelatedEquipment(getESPEquipments.length > 1);
    if (getESPEquipments.length > 1) {
      const totalStages = getESPEquipments.reduce(
        (sum: any, equipment: { noStgs?: any }) =>
          sum + (equipment.noStgs ?? 0),
        0
      );
      setpumpCalcDetails((prev) => ({
        ...prev,
        pump_DesrdStges: totalStages.toString(),
      }));
    }
  }, [getESPEquipments]);
  const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    const data = event?.target?.checked;
    updatehdnPmpShowAll(Number(data).toString());
  };

  const { pumpCalculationsCollapse } = useAppSelector(
    (state) => state?.collapse
  );

  const { updatePumpCalculationsCollapse } = useCollapseFacade();

  const handleCollapseChange = (key: boolean) => {
    updatePumpCalculationsCollapse(key);
  };

  const [pumpCalcDetails, setpumpCalcDetails] = useState({
    pump_ReqdTDH: "",
    pump_DesrdStges: "",
    pumpCalcDetailsHandlerFactors: {
      flow: "",
      head: "",
      power: "",
    },
  });

  const handleChange = (e: any) => {
    const { name, value } = e?.target;
    let inputValue = value?.split(" %")?.[0];
    let newValue = inputValue === "" ? "0" : inputValue;
    if (
      newValue !== "0" &&
      newValue.startsWith("0") &&
      !newValue.includes(".")
    ) {
      newValue = newValue.slice(1);
    }

    const isNumberField = ["pump_ReqdTDH", "pump_DesrdStges"]?.includes(name);
    const validNumberRegex = /^\d*\.?\d*$/;
    if (newValue !== "" && validNumberRegex.test(newValue) && isNumberField) {
      setpumpCalcDetails((prev: any) => ({ ...prev, [name]: newValue }));
    }
  };

  const handleBlur = async (e: any) => {
    const { name, value } = e?.target;

    if (name === "pump_ReqdTDH") {
      updatePumpReqdTDH(pumpCalcDetails?.pump_ReqdTDH);
    } else if (name === "pump_DesrdStges") {
      const inputValue = value?.trim();
      const prevValue = String(PumpInputData?.pump_DesrdStges ?? "");
      // Only proceed if value changed
      if (inputValue !== prevValue) {
        const parsedValue = Number(inputValue);
        updatePumpDesrdStges(parsedValue || Number(prevValue));

        const isManualOverride = inputValue !== '' && parsedValue !== 0;
        let messageShown = false;


        if (isManualOverride) {
          if (hasRelatedEquipment) {
            updateESPEquipmentsForPumps([]);
            updateSchematicEquipmentData();
            if (!messageShown) {
              setNotification(true);
              messageShown = true;
            }
          }
          setMOWarning(true);
          setIsManualOverride(true);
          updateHdnPumpShaftType("1");
        } else {
          if (getESPEquipments.length > 0) {
            const totalStages = getESPEquipments.reduce(
              (sum: any, equipment: { noStgs?: any }) =>
                sum + (equipment.noStgs ?? 0),
              0
            );
            setpumpCalcDetails((prev) => ({
              ...prev,
              pump_DesrdStges: totalStages.toString(),
            }));
          }
          updateHdnPumpShaftType("1");
        }
      }
    }
  };



  const handleCorrectionFactorsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event?.target;
    let inputValue = value?.split(" %")?.[0];
    let newValue = inputValue === "" ? "0" : inputValue;
    if (
      newValue !== "0" &&
      newValue.startsWith("0") &&
      !newValue.includes(".")
    ) {
      newValue = newValue.slice(1);
    }
    const isNumberField = [
      "flwCrrctnForPump",
      "hdCrrctnForPump",
      "pWRCrrctnForPump",
    ]?.includes(name);
    const validNumberRegex = /^\d*\.?\d*$/;
    if (newValue !== "" && validNumberRegex.test(newValue) && isNumberField) {
      setpumpCalcDetails((prev) => {
        let newState = { ...prev };
        if (name === "flwCrrctnForPump") {
          newState.pumpCalcDetailsHandlerFactors = { ...newState.pumpCalcDetailsHandlerFactors, flow: newValue }
        } else if (name === "hdCrrctnForPump") {
          newState.pumpCalcDetailsHandlerFactors = { ...newState.pumpCalcDetailsHandlerFactors, head: newValue }
        } else if (name === "pWRCrrctnForPump") {
          newState.pumpCalcDetailsHandlerFactors = { ...newState.pumpCalcDetailsHandlerFactors, power: newValue }
        }
        return newState;
      });
    }
    return;
  };

  const handleBlurCorrectionFactors = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === "flwCrrctnForPump") {
      OverrideCorrectionFactors({
        flowCorrection: Number(
          value || pumpCalcDetails?.pumpCalcDetailsHandlerFactors?.flow
        ),
        headCorrection: PumpInputDataCalculated?.hdCrrctnForPump ?? 0,
        powerCorrection: PumpInputDataCalculated?.pWRCrrctnForPump ?? 0,
      });
    } else if (name === "hdCrrctnForPump") {
      OverrideCorrectionFactors({
        flowCorrection: PumpInputDataCalculated?.flwCrrctnForPump ?? 0,
        headCorrection: Number(
          value || pumpCalcDetails?.pumpCalcDetailsHandlerFactors?.head
        ),
        powerCorrection: PumpInputDataCalculated?.pWRCrrctnForPump ?? 0,
      });
    } else if (name === "pWRCrrctnForPump") {
      OverrideCorrectionFactors({
        flowCorrection: PumpInputDataCalculated?.flwCrrctnForPump ?? 0,
        headCorrection: PumpInputDataCalculated?.hdCrrctnForPump ?? 0,
        powerCorrection: Number(
          value || pumpCalcDetails?.pumpCalcDetailsHandlerFactors?.power
        ),
      });
    }
  };


  const renderWarnings = () => {
    return (
      <>
        {+PumpInputDataCalculated?.minNoOfStages >
          +(PumpInputData?.pump_DesrdStges ?? 0) && (
            <div className='flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
              <Alert className='mr-2' />
              <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
                Required no. of stages less than min. no. of stages
              </p>
            </div>
          )}

        {PumpInputDataCalculated?.IPumpFreeGasWarningVisible === true && (
          <div className='flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-secondary-600 border-darkcolor-400'>
            <Alert className='mr-2' />
            <p className='text-[14px] font-bold leading-[20px] text-neutral-25'>
              Free gas content too high for the pump to handle
            </p>
          </div>
        )}
      </>
    );
  };
  return (
    <>
      {renderWarnings()}
      <div className="fixed top-4 right-4 z-[1005] flex flex-col space-y-4">
        {notification && <Notification
          type='warning'
          message='Pump correlations are cleared due to manual override on Desired No. Of Stages.'
          timeout={2000}
          width='full'
          onClose={() => setNotification(false)}
          isOpen={MOWarning}
        />
        }
      </div>

      {loading ? (
        <div className='absolute inset-0 flex justify-center items-center bg-darkcolor-700 bg-opacity-30'>
          <WidgetLoader isLoading={loading} />
        </div>
      ) : (
        <Accordion
          tooltipText='Formulas'
          title='Pump calculations'
          link={'/help?tab=Pump#PC'}
          isOpen={pumpCalculationsCollapse}
          onToggle={() => handleCollapseChange(!pumpCalculationsCollapse)}
          content={
            <>
              <div className='flex justify-center items-start p-4 gap-4 w-full'>
                <div className='flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2'>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25 text-[14px] font-normal'>
                      {LABELS.motorFullLoadSpeed60Hz}
                    </label>
                    <label className='text-neutral-25'>
                      <span className='mr-1'>
                        {PumpInputData.pump_FullLoadSp || 3500}
                      </span>
                      <span>{PumpInputData.actNamePump_MotorFullSpeed}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.totalDynamicHeadOverride}
                    </label>
                    <div className='relative w-[150px]'>
                      <TextShortInput
                        className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                        name='pump_ReqdTDH'
                        onChange={handleChange}
                        value={
                          pumpCalcDetails?.pump_ReqdTDH ||
                          PumpInputData?.pump_ReqdTDH
                        }
                        onBlur={handleBlur}
                        unit="ft"
                      />
                    </div>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>{LABELS.desiredNoStages}</label>
                    <TextShortInput
                      className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                      name='pump_DesrdStges'
                      onChange={handleChange}
                      value={
                        pumpCalcDetails?.pump_DesrdStges ||
                        PumpInputData?.pump_DesrdStges
                      }
                      onBlur={handleBlur}
                    />
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.minStages}
                    </label>
                    <label className='text-neutral-25'>
                      {PumpInputDataCalculated.minNoOfStages}
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.intakeSettingMD}
                    </label>
                    <label className='text-neutral-25'>
                      {intakeMD || "0"}
                    </label>
                  </div>
                </div>
                <div className='flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2 align-top'>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.liftPerStage}
                    </label>
                    <label className='text-neutral-25 fex space-x-2 mr-2'>
                      <span>{PumpInputDataCalculated.ftLftPerStage}</span>
                      <span>{PumpInputData.actNamePump_LiftPerStage}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.flowCorrection}
                    </label>
                    <div className='relative w-[140px]'>
                      {" "}
                      <TextShortInput
                        className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                        name='flwCrrctnForPump'
                        onChange={handleCorrectionFactorsChange}
                        value={
                          pumpCalcDetails?.pumpCalcDetailsHandlerFactors
                            ?.flow || PumpInputDataCalculated?.flwCrrctnForPump
                        }
                        onBlur={handleBlurCorrectionFactors}
                        unit=" %"
                      />
                    </div>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.headCorrection}
                    </label>

                    <div className='relative w-[140px]'>
                      <TextShortInput
                        className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                        name='hdCrrctnForPump'
                        onChange={handleCorrectionFactorsChange}
                        value={
                          pumpCalcDetails?.pumpCalcDetailsHandlerFactors
                            ?.head || PumpInputDataCalculated?.hdCrrctnForPump
                        }
                        onBlur={handleBlurCorrectionFactors}
                        unit=" %"
                      />
                    </div>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.powerCorrection}
                    </label>

                    <div className='relative w-[140px]'>
                      <TextShortInput
                        className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                        name='pWRCrrctnForPump'
                        onChange={handleCorrectionFactorsChange}
                        value={
                          pumpCalcDetails?.pumpCalcDetailsHandlerFactors
                            ?.power || PumpInputDataCalculated?.pWRCrrctnForPump
                        }
                        onBlur={handleBlurCorrectionFactors}
                        unit=" %"
                      />
                    </div>
                  </div>
                </div>
                <div className='flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2'>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      Power @ {fluidDetails.tab3Input?.operatngFreq} Hz
                    </label>
                    <label className='text-neutral-25 fex space-x-2'>
                      <span>{PumpInputDataCalculated.hPOPPump}</span>
                      <span>{PumpInputData.actNamePump_HP3500}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.powerAt60Hz}
                    </label>
                    <label className='text-neutral-25 fex space-x-2'>
                      <span>{PumpInputDataCalculated.hPOPPump60Hz}</span>
                      <span>{PumpInputData.actNamePump_HP3500}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.efficiency}
                    </label>
                    <label className='text-neutral-25'>
                      {PumpInputDataCalculated.efficiency} %
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.targetFlowRate}
                    </label>
                    <label className='text-neutral-25 fex space-x-2'>
                      <span>{targetFlowRateForPump?.preTFV}</span>
                      <span>{PumpInputData.actNamePump_DesiredFlowRate}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>{LABELS.finalTDH}</label>
                    <label className='text-neutral-25 fex space-x-2'>
                      <span>{PumpInputDataCalculated?.pmpFinalTDH}</span>
                      <span>{PumpInputData.actNamePump_RequiredTDH}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='w-full p-4'>
                <Checkbox
                  label='Show all pumps'
                  checked={tubingDetails?.tab1Input?.hdnPmpShowAll == "1"}
                  name='showAllPumps'
                  onChange={(e) => handleCheckbox(e)}
                />
              </div>
            </>
          }
        />
      )}
    </>
  );
};

export default PumpCalculationDetails;
